import Toggle from '@amzn/meridian/toggle';
import { useTheme as useMeridianTheme } from '@amzn/meridian/theme';
import { css } from '@emotion/css';

interface SidebarFooterProps {
  isDarkMode: boolean;
  onToggleTheme: () => void;
  userName: string;
  userAlias?: string;
  profilePhotoUrl?: string;
}

export default function SidebarFooter({
  isDarkMode,
  onToggleTheme,
  userName,
  userAlias,
  profilePhotoUrl,
}: SidebarFooterProps) {
  const meridianTheme = useMeridianTheme();

  const footerClass = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: 6,
    borderRadius: 12,
    border: `1px solid ${meridianTheme('themeBorderSubdued')}`,
    backgroundColor: meridianTheme('themeSurfaceDefault'),
  });
  const rowClass = css({
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
    padding: '6px 8px',
  });
  const settingLabelClass = css({
    flex: '1 1 auto',
    color: meridianTheme('themeInkSubdued'),
    fontSize: 13,
    fontWeight: 500,
  });
  const dividerClass = css({
    height: 1,
    margin: '0 8px',
    backgroundColor: meridianTheme('themeBorderSubdued'),
  });
  const photoClass = css({
    width: 28,
    height: 28,
    flex: '0 0 auto',
    borderRadius: '50%',
    objectFit: 'cover',
    boxShadow: `0 0 0 2px ${meridianTheme('themeSurfaceDefault')}, 0 0 0 3px ${meridianTheme('themeBorderSubdued')}`,
  });
  const identityClass = css({
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  });
  const userNameClass = css({
    overflow: 'hidden',
    color: meridianTheme('themeInkDefault'),
    fontSize: 13,
    fontWeight: 600,
    lineHeight: '18px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  });
  const aliasClass = css({
    color: meridianTheme('themeInkSubdued'),
    fontSize: 12,
    lineHeight: '16px',
  });

  return (
    <div className={footerClass}>
      <div className={rowClass}>
        <span className={settingLabelClass}>Dark mode</span>
        <Toggle checked={isDarkMode} onChange={onToggleTheme} size="small" aria-label="Toggle dark mode" />
      </div>
      <div className={dividerClass} />
      <div className={rowClass}>
        {profilePhotoUrl && <img src={profilePhotoUrl} alt={`${userName}'s profile photo`} className={photoClass} />}
        <span className={identityClass}>
          <span className={userNameClass} title={userName}>
            {userName}
          </span>
          {userAlias && userAlias !== userName && <span className={aliasClass}>{userAlias}@</span>}
        </span>
      </div>
    </div>
  );
}
